/* eslint-disable no-nested-ternary */
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${({ $sideBar }) => ($sideBar ? "20px 0 0" : "12px 16px")};
  border-radius: ${({ $billingTab }) => ($billingTab ? "8px" : "0")};
  margin: ${({ $billingTab }) => ($billingTab ? "16px 0" : "0")};
  border: ${({ $billingTab, $sideBar, theme }) =>
    $billingTab
      ? `1px solid ${theme.pallette.silver.secondary}`
      : !$sideBar
      ? `0 0 0 1px solid ${theme.pallette.silver.secondary}`
      : "none"};

  .ant-progress-bg {
    background-color: ${({ theme }) => theme.pallette.blue.link};
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 0 4px;
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.pallette.silver.primary};
`;

export const TitleBold = styled(Title)`
  font-weight: 500;
  color: ${({ theme }) => theme.pallette.blue.primary};
`;
